import apiClient from './apiClient';

export async function loginAdmin(credentials) {
  const response = await apiClient.post('/api/admin/auth/login', credentials);
  return response.data;
}

export async function logoutAdmin() {
  const response = await apiClient.post('/api/admin/auth/logout');
  return response.data;
}

export async function getAdminMe() {
  const response = await apiClient.get('/api/admin/auth/me');
  return response.data;
}

export async function getLeadStats() {
  const response = await apiClient.get('/api/admin/leads/stats/summary');
  return response.data;
}

export async function getAdminLeads(filters = {}) {
  const response = await apiClient.get('/api/admin/leads', {
    params: filters,
  });
  return response.data;
}

export async function updateLeadStatus(leadId, status) {
  const response = await apiClient.patch(`/api/admin/leads/${leadId}/status`, { status });
  return response.data;
}

export async function getAdminJobs() {
  const response = await apiClient.get('/api/admin/jobs');
  return response.data;
}

export async function getAdminJobCategories() {
  const response = await apiClient.get('/api/admin/jobs/categories');
  return response.data;
}

export async function createAdminJob(payload) {
  const response = await apiClient.post('/api/admin/jobs', payload);
  return response.data;
}

export async function updateAdminJob(jobId, payload) {
  const response = await apiClient.patch(`/api/admin/jobs/${jobId}`, payload);
  return response.data;
}

export async function deleteAdminJob(jobId) {
  const response = await apiClient.delete(`/api/admin/jobs/${jobId}`);
  return response.data;
}

export async function updateAdminJobStatus(jobId, status) {
  const response = await apiClient.patch(`/api/admin/jobs/${jobId}/status`, { status });
  return response.data;
}

export async function getAdminApplyForm() {
  const response = await apiClient.get('/api/admin/apply-form');
  return response.data;
}

export async function saveAdminApplyForm(payload) {
  const response = await apiClient.post('/api/admin/apply-form', payload);
  return response.data;
}

export async function getAdminTaskForm() {
  const response = await apiClient.get('/api/admin/task-form');
  return response.data;
}

export async function saveAdminTaskForm(payload) {
  const response = await apiClient.post('/api/admin/task-form', payload);
  return response.data;
}

export async function getAdminApplications(filters = {}) {
  const response = await apiClient.get('/api/admin/applications', { params: filters });
  return response.data;
}

export async function getAdminApplication(applicationId) {
  const response = await apiClient.get(`/api/admin/applications/${applicationId}`);
  return response.data;
}

export async function updateAdminApplicationStatus(applicationId, status, notes = '') {
  const response = await apiClient.patch(`/api/admin/applications/${applicationId}/status`, {
    status,
    notes,
  });
  return response.data;
}

export async function bulkUpdateAdminApplicationStatus(applicationIds, status) {
  const response = await apiClient.patch('/api/admin/applications/bulk-status', {
    applicationIds,
    status,
  });
  return response.data;
}

export async function addAdminApplicationsToEmailGroup(groupId, applicationIds) {
  const response = await apiClient.post('/api/admin/applications/groups/add-selected', {
    groupId,
    applicationIds,
  });
  return response.data;
}

export async function createAdminEmailGroupFromApplications(payload) {
  const response = await apiClient.post('/api/admin/applications/groups/create-from-selected', payload);
  return response.data;
}

export async function exportAdminApplicationsExcel(applicationIds) {
  const response = await apiClient.post(
    '/api/admin/applications/export-excel',
    { applicationIds },
    { responseType: 'blob' }
  );

  return response;
}

export async function getAdminTaskApplicants(filters = {}) {
  const response = await apiClient.get('/api/admin/task-applicants', { params: filters });
  return response.data;
}

export async function updateAdminTaskApplicantStatus(submissionId, status, notes = '') {
  const response = await apiClient.patch(`/api/admin/task-applicants/${submissionId}/status`, {
    status,
    notes,
  });
  return response.data;
}

export async function bulkUpdateAdminTaskApplicantStatus(submissionIds, status) {
  const response = await apiClient.patch('/api/admin/task-applicants/bulk-status', {
    submissionIds,
    status,
  });
  return response.data;
}

export async function addAdminTaskApplicantsToEmailGroup(groupId, submissionIds) {
  const response = await apiClient.post('/api/admin/task-applicants/groups/add-selected', {
    groupId,
    submissionIds,
  });
  return response.data;
}

export async function createAdminEmailGroupFromTaskApplicants(payload) {
  const response = await apiClient.post('/api/admin/task-applicants/groups/create-from-selected', payload);
  return response.data;
}

export async function exportAdminTaskApplicantsExcel(submissionIds) {
  const response = await apiClient.post(
    '/api/admin/task-applicants/export-excel',
    { submissionIds },
    { responseType: 'blob' }
  );

  return response;
}

export async function sendApplicationFormEmail(payload) {
  const response = await apiClient.post('/api/admin/applications/send-application-email', payload);
  return response.data;
}

export async function sendApplicationStageEmail(payload) {
  const response = await apiClient.post('/api/admin/applications/send-stage-email', payload);
  return response.data;
}

export async function getApplicationEmailLogs() {
  const response = await apiClient.get('/api/admin/application-email-logs');
  return response.data;
}

export async function getAdminEmails(filters = {}) {
  const response = await apiClient.get('/api/admin/emails', { params: filters });
  return response.data;
}

export async function getAdminEmailConfig() {
  const response = await apiClient.get('/api/admin/emails/config');
  return response.data;
}

export function getAdminEmailAttachmentDownloadUrl(downloadPath) {
  const fallbackOrigin = typeof window !== 'undefined' ? window.location.origin : '';

  try {
    return new URL(downloadPath, apiClient.defaults.baseURL || fallbackOrigin).toString();
  } catch (error) {
    return downloadPath;
  }
}

function buildEmailFormData(payload) {
  const { attachments = [], ...fields } = payload;
  const formData = new FormData();

  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value || '');
  });

  attachments.forEach((file) => {
    formData.append('attachments', file);
  });

  return formData;
}

async function postAdminEmailPayload(url, payload) {
  if (payload.attachments?.length) {
    const response = await apiClient.post(url, buildEmailFormData(payload), {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  const fields = { ...payload };
  delete fields.attachments;
  const response = await apiClient.post(url, fields);
  return response.data;
}

export async function bulkSendAdminEmail(payload) {
  return postAdminEmailPayload('/api/admin/emails/bulk-send', payload);
}

export async function getAdminEmailBulkSendStatus(jobId) {
  const response = await apiClient.get(`/api/admin/emails/bulk-send/${jobId}`);
  return response.data;
}

export async function sendAdminEmail(payload) {
  return postAdminEmailPayload('/api/admin/emails/send', payload);
}

export async function replyAdminEmail(emailId, payload) {
  const response = await apiClient.post(`/api/admin/emails/${emailId}/reply`, payload);
  return response.data;
}

export async function updateAdminEmailReadStatus(emailId, readStatus) {
  const response = await apiClient.patch(`/api/admin/emails/${emailId}/read`, { readStatus });
  return response.data;
}

export async function archiveAdminEmail(emailId) {
  const response = await apiClient.patch(`/api/admin/emails/${emailId}/archive`);
  return response.data;
}

export async function getAdminEmailLogs() {
  const response = await apiClient.get('/api/admin/emails/logs');
  return response.data;
}

export async function getAdminEmailUnsubscribes() {
  const response = await apiClient.get('/api/admin/emails/unsubscribes');
  return response.data;
}

export async function addAdminEmailUnsubscribe(payload) {
  const response = await apiClient.post('/api/admin/emails/unsubscribes', payload);
  return response.data;
}

export async function deleteAdminEmailUnsubscribe(unsubscribeId) {
  const response = await apiClient.delete(`/api/admin/emails/unsubscribes/${unsubscribeId}`);
  return response.data;
}

export async function getAdminEmailGroups() {
  const response = await apiClient.get('/api/admin/emails/groups');
  return response.data;
}

export async function createAdminEmailGroup(payload) {
  const response = await apiClient.post('/api/admin/emails/groups', payload);
  return response.data;
}

export async function updateAdminEmailGroup(groupId, payload) {
  const response = await apiClient.patch(`/api/admin/emails/groups/${groupId}`, payload);
  return response.data;
}

export async function deleteAdminEmailGroup(groupId) {
  const response = await apiClient.delete(`/api/admin/emails/groups/${groupId}`);
  return response.data;
}

export async function removeAdminEmailFromGroup(groupId, emailId) {
  const response = await apiClient.delete(`/api/admin/emails/groups/${groupId}/emails/${emailId}`);
  return response.data;
}

export async function verifyMarketingUnsubscribe(token) {
  const response = await apiClient.get(`/unsubscribe/${token}`);
  return response.data;
}

export async function confirmMarketingUnsubscribe(token) {
  const response = await apiClient.post(`/unsubscribe/${token}`);
  return response.data;
}
